import React, { memo, FC, useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { FormikErrors, FormikTouched, FormikValues } from 'formik';
import { useStyles } from '../../styles';
import useGetTranslatedOptions from '../useGetTranslatedOptions';
import { ValueLabel } from '../../../../../models';
import { LinkConfiguration } from '../../../RegistrationLinksModel';
import { InputField, SelectField } from '../../../../../components';

interface Props {
  translation: any;
  linkConfigurations: LinkConfiguration[];
  touched?: FormikTouched<FormikValues>;
  errors?: FormikErrors<FormikValues>;
}

export const CreatePartnershipLinkTab: FC<Props> = memo(({ linkConfigurations, translation, touched, errors }) => {
  const [subIBOptions, setSubIBOptions] = useState<ValueLabel[]>([]);
  const classes = useStyles();
  const getOptions = useGetTranslatedOptions(translation);

  useEffect(() => {
    setSubIBOptions(getOptions(linkConfigurations, 'schemeName', 'configurationId'));
  }, [linkConfigurations, getOptions]);

  return (
    <>
      <Grid item xs={12}>
        <InputField name="linkName" label={translation.link_name} />
      </Grid>
      <Grid item xs={6}>
        <div className={classes.fieldContainer}>
          <SelectField name="linkConfigurationId" label={translation.text_579} errors={touched?.linkConfigurationId ? errors?.linkConfigurationId : undefined} options={subIBOptions} isRequired />
        </div>
      </Grid>
      <Grid item xs={6}>
        <div className={classes.shortcodeContainer}>
          <InputField
            name="shortCode"
            label={translation.text_1631}
            // icon={
            //   <LightTooltip title={translation.text_1632}>
            //     <InfoOutlined className={classes.input} />
            //   </LightTooltip>
            // }
            errors={touched?.shortCode ? errors?.shortCode : undefined}
          />
        </div>
      </Grid>
    </>
  );
});
